import { render, staticRenderFns } from "./pageWrap.vue?vue&type=template&id=1b6e7cde&scoped=true"
import script from "./pageWrap.vue?vue&type=script&lang=js"
export * from "./pageWrap.vue?vue&type=script&lang=js"
import style0 from "./pageWrap.vue?vue&type=style&index=0&id=1b6e7cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6e7cde",
  null
  
)

export default component.exports